.logo-container {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    font-weight: 600;
  }
  
  .logo-icon {
    font-size: 1.2em;
  }
  
  /* Colors */
  .logo-color-default {
    color: #2D3748;
  }
  
  .logo-color-white {
    color: white;
  }
  
  .logo-color-primary {
    color: #635BFF;
  }
  
  /* Sizes */
  .logo-size-small {
    font-size: 16px;
  }
  
  .logo-size-medium {
    font-size: 20px;
  }
  
  .logo-size-large {
    font-size: 24px;
  }